var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Legenda',{attrs:{"titulo":"Sugestão em galão","legenda":_vm.TXT_CALCULO}},[_vm._v("\n  "+_vm._s(_vm.GALONAGEM)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }